import {
  getOptionalVText,
  getTextContainerForRelativeOffset,
  initVTextNodes,
  sliceVTextNode,
  splitVTextNode,
} from './vTextNode.js'
import { getTextNodes, guid } from './util.js'

const markSelector = 'data-selector'

class Marker {
  _element
  _selection
  _configs = {
    isCover: true, // 是否允许覆盖
    ignoreClass: [], // 划词忽略的class
  }
  onSelected = null
  onClick = null

  constructor(ops) {
    const ele = this._element = ops.el
    this._selection = window.getSelection()

    if(ops.options) {
      this._configs = { ...this._configs, ...ops.options }
    }

    if(this._configs.ignoreClass.length > 0) {
      this._setEleNoSelect(this._element, this._configs.ignoreClass)
    }

    initVTextNodes(getTextNodes(ele, this._configs.ignoreClass))
  }

  // 设置不可选的dom
  _setEleNoSelect(ele, classNames) {
    classNames.map(item => {
      const hitEle = ele.querySelectorAll(`.${item}`)
      if(!hitEle) return
      for(let i = 0; i < hitEle.length; i++) {
        const element = hitEle[i]
        element.style.userSelect = 'none'
      }
    })
  }

  // 判断选取是否被覆盖
  _hasCoverSelector(range, attrName) {
    let hasCover = false
    if(range.cloneContents().querySelector(`[${attrName}]`)) {
      hasCover = true // 1.选中范围内存在已经标注的节点
    } 
    else {
      if(range.commonAncestorContainer.parentNode?.nodeType === 1) {
        const pNode = range.commonAncestorContainer.parentNode
        if(pNode.getAttribute(attrName)) {
          hasCover = true // 2.选中范围内在已经标注节点内部
        }
      }
    }
    return hasCover
  }

  // 获取选区数据
  _getSelection(range) {
    const selection = this._selection
    if(!selection) return

    if(range.startContainer.nodeType !== 3 || range.endContainer.nodeType !== 3) {
      selection.removeAllRanges()
      return
    }

    if(!this._configs.isCover && !range.storeRenderOther && this.hasCoverSelector(range, markSelector)) {
      selection.removeAllRanges()
      return
    }

    const sCntr = range.startContainer
    const eCntr = range.endContainer
    let endTextNext = splitVTextNode(eCntr, range.endOffset)
    const startText = splitVTextNode(sCntr, range.startOffset)

    if(!startText || !endTextNext) return

    if(this._configs.ignoreClass.length > 0) {
      endTextNext = getOptionalVText(endTextNext)
    }

    if(!endTextNext) return

    const textNodes = sliceVTextNode(startText, endTextNext, this._configs.ignoreClass.length > 0) || []
    const offset = startText.offset
    const relativeOffset = startText.relativeOffset

    let text = ''
    textNodes?.map(item => text += item.textContent)

    return {
      text,
      offset,
      relativeOffset,
      // eslint-disable-next-line no-prototype-builtins
      hasStoreRender: range.hasOwnProperty('storeRenderOther'),
      textNodes,
      storeRenderOther: range && range.storeRenderOther ? range.storeRenderOther : {},
      selection,
      range,
    }
  }

  // 移除选取标记
  _removeMark(eleS) {
    eleS.forEach(node => {
      if(node.parentNode) {
        const fragment = document.createDocumentFragment()
        const childNodes = node.childNodes
        for(let i = 0; i < childNodes.length; i++) {
          const node = childNodes[i]
          fragment.appendChild(node.cloneNode(true))
        }
        node.parentNode.replaceChild(fragment, node)
      }
    })
    initVTextNodes(getTextNodes(this._element, this._configs.ignoreClass))
  }

  select() {
    const selection = this._selection
    const range = selection.getRangeAt(0)
    return this._getSelection(range)
  }

  renderStore(obj) {
    if(!this._selection) return

    obj.map((item) => {
      const end = item.relativeOffset + item.text.length
      const startContainer = getTextContainerForRelativeOffset(item.nodeId, item.relativeOffset)
      const endContainer = getTextContainerForRelativeOffset(item.nodeId, end)

      if(startContainer && endContainer) {
        const endOffset = end - endContainer.relativeOffset
        const startOffset = item.relativeOffset - startContainer.relativeOffset

        const obj = {
          collapsed: false,
          commonAncestorContainer: this._element,
          startContainer: startContainer.text,
          endContainer: endContainer.text,
          endOffset,
          startOffset,
          storeRenderOther: item,
        }
        const ret = this._getSelection(obj)

        this.repaintRange({
          uuid: ret.storeRenderOther.uid,
          textNodes: ret.textNodes,
          className: ret.storeRenderOther.className || 'selected-range',
        })
      }
    })
  }

  repaintRange(rangeNode) {
    const {
      uuid,
      className,
      textNodes,
    } = rangeNode

    const uid = uuid || guid()

    textNodes.forEach(node => {
      if(node.parentNode) {
        const hl = document.createElement('span')
        if(className) hl.className = className
        else hl.style.background = 'rgba(255, 255, 0, 0.3)'

        hl.setAttribute(markSelector, uid)
        node.parentNode.replaceChild(hl, node)
        hl.appendChild(node)
      }
    })
    return { uid }
  }

  deleteMark(uid) {
    const eleArr = document.querySelectorAll(`span[${markSelector}='${uid}']`)
    this._removeMark(eleArr)
  }

  replaceMarkClass(uid, className) {
    const eleArr = document.querySelectorAll(`span[${markSelector}='${uid}']`)
    eleArr.forEach(node => node.className = className)
  }

  destroy() {
    this._selection = null
  }
}

export default Marker